module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/customize_mobile-f9be411a22f3ff83656a58564d12688d.png";